import React from 'react';

/* Iconos inline. Reemplazan a Font Awesome en la home: pesan ~1 KB en total
   y no requieren ninguna dependencia. */

const s = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, 'aria-hidden': true };

export const IconPin = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Z" /><circle cx="12" cy="10" r="2.6" /></svg>
);
export const IconPhone = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z" /></svg>
);
export const IconMail = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>
);
export const IconArrow = (p) => (
  <svg viewBox="0 0 24 24" {...s} strokeWidth="2" {...p}><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
);
export const IconChevronRight = (p) => (
  <svg viewBox="0 0 24 24" {...s} strokeWidth="2" {...p}><path d="m9 6 6 6-6 6" /></svg>
);
export const IconChevronDown = (p) => (
  <svg viewBox="0 0 24 24" {...s} strokeWidth="2.4" {...p}><path d="m6 9 6 6 6-6" /></svg>
);
export const IconCheck = (p) => (
  <svg viewBox="0 0 24 24" {...s} strokeWidth="2" {...p}><path d="m5 13 4 4L19 7" /></svg>
);
export const IconShield = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><path d="M12 3 4 6v6c0 5 3.4 8.3 8 9 4.6-.7 8-4 8-9V6l-8-3Z" /><path d="m9 12 2 2 4-4" /></svg>
);
export const IconCalendar = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><rect x="3" y="5" width="18" height="16" rx="3" /><path d="M8 3v4M16 3v4M3 10h18" /></svg>
);
export const IconHeart = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 1 0-7.8 7.8l8.8 8.8 8.8-8.8a5.5 5.5 0 0 0 0-7.8Z" /></svg>
);
export const IconClock = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
);
export const IconStar = (p) => (
  <svg viewBox="0 0 24 24" {...s} strokeWidth="1.5" {...p}><path d="m12 3 2.6 5.6 6.1.8-4.5 4.2 1.2 6-5.4-2.9L6.6 19.6l1.2-6-4.5-4.2 6.1-.8L12 3Z" /></svg>
);
export const IconBadgeCheck = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><circle cx="12" cy="12" r="9" /><path d="m8.5 12.5 2.4 2.4 4.6-5.2" /></svg>
);
export const IconInfo = (p) => (
  <svg viewBox="0 0 24 24" {...s} strokeWidth="2" {...p}><circle cx="12" cy="12" r="9" /><path d="M12 8h.01M11 12h1v4h1" /></svg>
);
export const IconSearch = (p) => (
  <svg viewBox="0 0 24 24" {...s} strokeWidth="2" {...p}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
);
export const IconList = (p) => (
  <svg viewBox="0 0 24 24" {...s} strokeWidth="2" {...p}><path d="M4 6h16M4 12h16M4 18h10" /></svg>
);
export const IconUser = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><circle cx="12" cy="8" r="3.6" /><path d="M4.5 20a7.5 7.5 0 0 1 15 0" /></svg>
);
export const IconParking = (p) => (
  <svg viewBox="0 0 24 24" {...s} {...p}><path d="M3 11h18M5 11V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4M6 19v-2M18 19v-2" /></svg>
);
export const IconPlay = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M8 5v14l11-7z" /></svg>
);

/* Redes */
export const IconWhatsapp = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2Zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-1.7-.1a12 12 0 0 1-5.6-4.9c-.4-.7-.9-1.6-.9-2.5s.5-1.4.7-1.6c.2-.2.4-.3.6-.3h.5c.2 0 .4 0 .6.4l.8 1.9c.1.2 0 .4-.1.5l-.4.5c-.1.2-.3.3-.1.6a8 8 0 0 0 3.6 3.1c.3.1.4.1.6-.1l.7-.8c.2-.2.3-.2.6-.1l1.8.9c.2.1.3.2.4.3v.8Z" /></svg>
);
export const IconFacebook = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.5 1.6-1.5h1.6V5c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4V11H7.8v3h2.7v8h3Z" /></svg>
);
export const IconInstagram = (p) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" aria-hidden="true" {...p}><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none" /></svg>
);
export const IconYoutube = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M22.5 7.2a2.8 2.8 0 0 0-2-2C18.8 4.7 12 4.7 12 4.7s-6.8 0-8.5.5a2.8 2.8 0 0 0-2 2C1 8.9 1 12 1 12s0 3.1.5 4.8a2.8 2.8 0 0 0 2 2c1.7.4 8.5.4 8.5.4s6.8 0 8.5-.4a2.8 2.8 0 0 0 2-2c.5-1.7.5-4.8.5-4.8s0-3.1-.5-4.8ZM9.8 15.3V8.7l5.7 3.3-5.7 3.3Z" /></svg>
);
export const IconTiktok = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M16.6 5.8a4.8 4.8 0 0 1-1.1-3.1h-3.1v12.4a2.6 2.6 0 1 1-1.9-2.5V9.4a5.7 5.7 0 1 0 5 5.6V9.1a7.8 7.8 0 0 0 4.5 1.4V7.4a4.8 4.8 0 0 1-3.4-1.6Z" /></svg>
);
